<template>
    <div class="content">
        <img src="../assets/images/logo.png" alt="" class="logo" />
        <div class="list">
            <div
                class="listLi"
                v-if="tabName != 'home'"
                @click="chooseTab('/home')"
            >
                <img src="../assets/images/home.png" alt="" />
                <div class="listName">发送</div>
            </div>
            <div
                class="listLi"
                v-if="tabName == 'home'"
                @click="chooseTab('/home')"
            >
                <div class="lineLeft"></div>
                <img src="../assets/images/homeActive.png" alt="" />
                <div class="listName listNameA">发送</div>
            </div>

            <div
                class="listLi"
                v-if="tabName == 'transferPage'"
                @click="chooseTab('/transferPage')"
            >
                <div class="lineLeft"></div>

                <img src="../assets/images/jsActive.png" alt="" />
                <div class="listName listNameA">接收</div>
            </div>
            <div
                class="listLi"
                v-if="tabName != 'transferPage'"
                @click="chooseTab('/transferPage')"
            >
                <img src="../assets/images/js.png" alt="" />
                <div class="listName">接收</div>
            </div>
            <div
                class="listLi"
                v-if="tabName != 'transmitPage'"
                @click="chooseTab('/transmitPage')"
            >
                <img src="../assets/images/cs.png" alt="" />
                <div class="listName">传输</div>
            </div>
            <div
                class="listLi"
                v-if="tabName == 'transmitPage'"
                @click="chooseTab('/transmitPage')"
            >
                <div class="lineLeft"></div>

                <img src="../assets/images/csActive.png" alt="" />
                <div class="listName listNameA">传输</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            tabName: 'home'
        }
    },
    watch: {
        $route(to) {
            // 监听路由变化，根据需要调整showFooter的值
            this.tabName = to.name
        }
    },
    methods: {
        chooseTab(url) {
            this.$router.push({ path: url })
        }
    }
}
</script>

<style lang="scss" scoped>
.content {
    width: 100px;
    border-right: 1px solid #ecedfc;
    padding: 26px 0 0;
    text-align: center;
}
.logo {
    width: 55.82px;
    height: 75.85px;
}
.list {
    margin-top: 114px;

    .listLi {
        margin-bottom: 50px;
        position: relative;
        .lineLeft {
            width: 4px;
            height: 35px;
            opacity: 1;
            background: #0195ff;
            position: absolute;
            left: 0;
            top: 20%;
            border-radius: 0 20px 20px 0;
        }
        img {
            width: 37px;
            height: 37px;
        }
        .listName {
            color: #747b8a;
            font-size: 15px;
            font-weight: 500;
            font-family: 'HarmonyOSSansSC';
        }
        .listNameA {
            color: #0195ff;
        }
    }
}
@media screen and (max-width: 768px) {
    .content {
        width: 100% !important;
        height: 80px !important;
        padding: 0 !important;
        border-right: none !important;
        border-top: 1px solid #ecedfc;
        position: fixed;
        bottom: 0;
        left: 0;
        background: white;
        z-index: 1000;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .logo {
        display: none; /* 移动端隐藏logo */
    }

    .list {
        margin-top: 0 !important;
        display: flex;
        justify-content: space-around;
        width: 100%;
        height: 100%;

        .listLi {
            margin-bottom: 0 !important;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 25%;
            height: 100%;
            position: relative;

            .lineLeft {
                width: 100% !important;
                height: 4px !important;
                top: 0 !important;
                left: 0 !important;
                border-radius: 0 0 20px 20px !important;
            }

            img {
                width: 24px !important;
                height: 24px !important;
                margin-bottom: 5px;
            }

            .listName {
                font-size: 12px !important;
            }
        }
    }
}
</style>